import { Article } from 'src/services/articles/types/article';
import React from 'react';
import styled from 'styled-components';
import { ArticleCardWithImageVariant } from '@shapegames/web-library-quick-draw-ui/dist/AticleCardWithImage';
import { ARTICLES_LAYOUTS_GAP } from 'src/constants/layout';
import ArticlesGroupItem from '../ArticlesGroupItem';

const gap = ARTICLES_LAYOUTS_GAP;

export default function LayoutGridSecondary({
  articles,
}: {
  articles: Article[];
}) {
  const setup = [
    ['vertical', 'horizontalSquared', 'horizontalSquared', 'horizontalWide'],
    'vertical',
    ['vertical', 'vertical', 'vertical', 'horizontalSquared'],
  ] as ArticleCardWithImageVariant[];

  return (
    <GridLayoutCss>
      {articles.slice(0, 3).map((art, idx) => (
        <ArticlesGroupItem
          key={`article-${idx}`}
          variant={setup[idx]}
          article={art}
        />
      ))}
    </GridLayoutCss>
  );
}

const GridLayoutCss = styled.div`
  & > div {
    min-width: 0;
  }

  ${p => p.theme.breakpoints.maxSm} {
    display: flex;
    flex-direction: column;
    & > div:not(:last-child) {
      margin-bottom: ${gap};
    }
  }

  ${p => p.theme.breakpoints.sm} {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: ${gap};
    grid-row-gap: ${gap};

    ${p => p.theme.breakpoints.maxLg} {
      & > div:first-child {
        grid-area: 1 / 1 / 2 / 7;
      }

      & > div:nth-child(2) {
        grid-area: 2 / 1 / 3 / 4;
      }

      & > div:nth-child(3) {
        grid-area: 2 / 4 / 3 / 7;
      }
    }
  }

  ${p => p.theme.breakpoints.lg} {
    ${p => p.theme.breakpoints.maxXl} {
      & > div:first-child {
        grid-area: 1 / 1 / 2 / 7;
      }

      & > div:nth-child(2) {
        grid-area: 2 / 1 / 3 / 4;
      }

      & > div:nth-child(3) {
        grid-area: 2 / 4 / 3 / 7;
      }
    }
  }
  ${p => p.theme.breakpoints.xl} {
    & > div:first-child {
      grid-area: 1 / 1 / 2 / 7;
    }

    & > div:nth-child(2) {
      grid-area: 2 / 1 / 3 / 3;
    }

    & > div:nth-child(3) {
      grid-area: 2 / 3 / 3 / 7;
    }
  }
`;
